import React from "react";
import { RiResetLeftLine } from "react-icons/ri";
import { STATUS_OPTIONS,  SOURCE_OPTIONS } from '../Constant/leadConstent';

const LeadFilters = ({
  showFilter,
  filters,
  filteredStatusOptions = [],
  onFilterChange,
  onApplyFilters,
  onResetFilters,
  onToggleFilter,
}) => {
  if (!showFilter) return null;
// Status ke according color dene ke liye function
const getStatusStyle = (status) => {
    const statusOption = STATUS_OPTIONS.find(opt => opt.value === status);
    return statusOption || { bgLight: "bg-gray-100", textColor: "text-gray-800" };
};
  return (
    <div className="card mb-3">
      <div className="card-header bg-white d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">
          <i className="fas fa-filter me-2"></i>
          Filters
        </h5>
        <div className="d-flex gap-2">
          <button 
            className="btn btn-success btn-sm" 
            onClick={onApplyFilters}
          >
            <i className="fas fa-search me-1"></i>
            Apply Filter
          </button>
          <button 
            className="btn btn-secondary btn-sm" 
            onClick={onResetFilters}
          >
            <RiResetLeftLine className="me-1" /> Reset
          </button>
          <button 
            className="btn btn-dark btn-sm" 
            onClick={onToggleFilter}
          >
            <i className="fas fa-times me-1"></i>
            Close
          </button>
        </div>
      </div>
      <div className="card-body">
        <div className="row g-2">
          <div className="col-md-3">
            <label className="form-label fw-semibold">Status</label>
            <select
              name="status"
              value={filters.status || ""}
              onChange={onFilterChange}
              className="form-select form-select-sm"
            >
              <option value="">All Status</option>
              {filteredStatusOptions.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.value}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label fw-semibold">Source</label>
            <select
              name="source"
              value={filters.source || ""}
              onChange={onFilterChange}
              className="form-select form-select-sm"
            >
              {SOURCE_OPTIONS.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label fw-semibold">Customer Name</label>
            <input
              type="text"
              name="customer_name"
              value={filters.customer_name || ""}
              onChange={onFilterChange}
              placeholder="Enter customer name"
              className="form-control form-control-sm"
            />
          </div>

          <div className="col-md-3">
            <label className="form-label fw-semibold">Mobile</label>
            <input
              type="text"
              name="mobile"
              value={filters.mobile || ""}
              onChange={onFilterChange}
              placeholder="Enter mobile number"
              className="form-control form-control-sm"
            />
          </div>
{/* 
          <div className="col-md-3">
            <label className="form-label fw-semibold">Search</label>
            <input
              type="text"
              name="search"
              value={filters.search || ""}
              onChange={onFilterChange}
              placeholder="Search (name, email, etc.)"
              className="form-control form-control-sm"
            />
          </div> */}

          <div className="col-md-3">
            <label className="form-label fw-semibold">From Date</label>
            <input
              type="date"
              name="from_date"
              value={filters.from_date || ""}
              onChange={onFilterChange}
              className="form-control form-control-sm"
            />
          </div>

          <div className="col-md-3">
            <label className="form-label fw-semibold">To Date</label>
            <input
              type="date"
              name="to_date"
              value={filters.to_date || ""}
              onChange={onFilterChange}
              className="form-control form-control-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadFilters;